/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Share_Modal_Copy_LinkInputs */

const es_chat_share_modal_copy_link = /** @type {(inputs: Chat_Share_Modal_Copy_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copiar enlace`)
};

const en_chat_share_modal_copy_link = /** @type {(inputs: Chat_Share_Modal_Copy_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copy link`)
};

/**
* | output |
* | --- |
* | "Copy link" |
*
* @param {Chat_Share_Modal_Copy_LinkInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const chat_share_modal_copy_link = /** @type {((inputs?: Chat_Share_Modal_Copy_LinkInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Share_Modal_Copy_LinkInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_chat_share_modal_copy_link(inputs)
	return en_chat_share_modal_copy_link(inputs)
});
export { chat_share_modal_copy_link as "chat.share_modal.copy_link" }